import React, { useState } from 'react'
import Profile from './profile/profile'
import { QuickCreate } from './quick-create'
import { HorizontalStack, ShowOnlyOnScreenSize } from '@ztechapps/webui.util'
import { DbRestoreButton } from '@ztechapps/webui.page'
import { LogoWithName } from '../../components/logo/LogoWithName'
import { Navbar, Offcanvas } from 'react-bootstrap'
import { MenuBar } from './menu-bar'
import { BusyButton } from '@ztechapps/webui.button'
import { usePageLifecycle } from '@ztechapps/common.hook'
import { MOBILE_BREAKING_POINT } from '../../config/constants'
import { NotificationBell } from './notification'
import { GlobalSearchWrapper } from './GlobalSearchWrapper'
import { GlobalShortcuts } from './GlobalShortcuts'

export default function Header() {
  return (
    <Navbar className="header" expand="lg" fixed="top">
      <Navbar.Brand>
        <LogoWithName />
      </Navbar.Brand>

      <ShowOnlyOnScreenSize size={'desktop'} breakingPoint={MOBILE_BREAKING_POINT}>
        <TopBarContent />
      </ShowOnlyOnScreenSize>

      <ShowOnlyOnScreenSize size={'mobile'} breakingPoint={MOBILE_BREAKING_POINT}>
        <OffCanvasMenu />
      </ShowOnlyOnScreenSize>
    </Navbar>
  )
}

const OffCanvasMenu = () => {
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  usePageLifecycle(null, handleClose)

  return (
    <div className="me-2">
      <BusyButton icon="bars" onClick={handleShow} />

      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <LogoWithName />
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <TopBarContent />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  )
}

const TopBarContent = () => {
  return (
    <>
      <MenuBar />
      <div className="mx-3 flex-grow-1">
        <GlobalSearchWrapper />
      </div>
      <nav className="ms-auto">
        <HorizontalStack gap={2} className="align-items-center">
          <NotificationBell />
          <DbRestoreButton />
          <GlobalShortcuts />
          <QuickCreate />
          <Profile />
        </HorizontalStack>
      </nav>
    </>
  )
}
